import fetchModels from "../../mixin/store/api/fetchModels";
import fetchModel from "@/mixin/store/api/fetchModel";
import changeOrPushModel from "@/mixin/store/api/changeOrPushModel";
import pushModel from "../../mixin/store/api/pushModel";
import deleteModel from "../../mixin/store/api/deleteModel";
import axios from "axios";
import changeModel from "../../mixin/store/api/changeModel";

export default {
    actions: {
        fetchSuppliers(context, page) {
            if (context.state.suppliers.isNeedFetch) {
                return fetchModels(context, 'suppliers?order[id]=desc', page, 'updateSuppliers');
            }
        },
        fetchSuppliersTotalCredit(context, page) {
            return fetchModels(context, 'suppliers/totalCredit', page, 'updateSuppliers');
        },
        fetchSupplier(context, id) {
            return fetchModel(context, 'suppliers', id, 'updateSupplier');
        },
        fetchSupplierFee(context, id) {
            return fetchModel(context, 'suppliers/' + id + '/fee', null, 'updateFee');
        },
        fetchSupplierPurchasesTotalAmount(context, id) {
            return fetchModel(context, 'suppliers/' + id + '/purchasesTotalAmount', null, 'updateSupplierPurchasesTotalAmount');
        },
        putSupplier(context, data) {
            if (data.debt === '') {
                data.debt =  null;
                data.currency = null
            }

            return changeOrPushModel(context, data.url, data, 'updateSupplier')
        },
        pushSupplier(context, data) {
            if (data.debt === '') {
                data.debt =  null;
                data.currency = null
            }

            return pushModel(context, 'suppliers', data)
        },
        deleteSupplier(context, id) {
            return deleteModel(context, 'suppliers', id)
        },
        searchSupplier(context, searchItem) {
            let url = "suppliers/totalCredit?page=" + searchItem.page
            let isSearch = false;

            if (searchItem.givenName) {
                url = url + '&personGivenName=' + searchItem.givenName
                isSearch = true;
            }

            if (searchItem.familyName) {
                url = url + '&personFamilyName=' + searchItem.familyName
                isSearch = true;
            }

            if (searchItem.companyName) {
                url = url + '&companyName=' + searchItem.companyName
                isSearch = true;
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSuppliers', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        payToSupplier(context, data) {
            return changeModel(context, 'suppliers/' + data.id + '/pay', data)
        },
    },
    mutations: {
        updateSuppliers(state, data) {
            state.suppliers = data
            state.suppliers.isNeedFetch = false
        },
        updateSupplier(state, data) {
            state.supplier = data
        },
        updateFee(state, data) {
            state.fee = data
        },
        updateSupplierPurchasesTotalAmount(state, data) {
            state.totalAmount = data['hydra:member']
        },
    },
    state: {
        fee: {},
        totalAmount: [],
        supplier: {
            id: null,
            person: null,
            supplierCompany: null,
            isCompany: true
        },
        suppliers: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSuppliers(state) {
            return state.suppliers.models
        },
        getSupplier(state) {
            return state.supplier
        },
        getSupplierFee(state) {
            return state.fee
        },
        getSupplierPurchasesTotalAmount(state) {
            return state.totalAmount
        },
        getSuppliersTotalCount(state) {
            return state.suppliers.totalItems
        }
    },
}
